document.addEventListener('DOMContentLoaded', () => {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  const headings = Array.from(policyBody.querySelectorAll('h2, h3'));
  const contactHeading = headings.find((heading) => heading.textContent.trim().toLowerCase() === 'contact');
  if (!contactHeading) return;

  let sibling = contactHeading.nextElementSibling;
  while (sibling && !/^H[23]$/.test(sibling.tagName)) {
    const next = sibling.nextElementSibling;
    sibling.remove();
    sibling = next;
  }

  const safeContact = document.createElement('p');
  safeContact.textContent = 'Questions about this Privacy Policy? Email support@tailandtarmac.com.';
  contactHeading.insertAdjacentElement('afterend', safeContact);
});
